import { useMemo } from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';

import _ from 'lodash';

import { useTranslation } from 'react-i18next';

import { ChevronDownIcon } from '@heroicons/react/16/solid';
import { LANGUAGES_FLAGS, LanguageFullNameEnum, LanguageEnum } from 'utils/constants';

import LanguageItem from './LanguageItem';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const flagImg = useMemo(() => {
    return LANGUAGES_FLAGS[i18n.language as LanguageEnum];
  }, [i18n.language]);

  return (
    <Menu>
      <MenuButton className='flex items-center gap-[8px] bg-beige rounded-[8px] p-[6px] focus:not-data-focus:outline-none'>
        <div className='flex items-center gap-[6px] cursor-pointer'>
          <img src={flagImg} className='w-[16px] h-[16px] rounded-[50%]' />
          <div className='text-grey500 font-[MuseoSans900] uppercase tracking-[1.5px]'>{i18n.language}</div>
        </div>
        <ChevronDownIcon className='size-4 fill-grey500' />
      </MenuButton>
      <MenuItems
        transition
        anchor='bottom'
        className='border border-beige bg-white py-[12px] px-[6px] rounded-[8px] flex flex-col gap-[6px] transition duration-100 ease-out [--anchor-gap:--spacing(1)] focus:outline-none data-closed:scale-95 data-closed:opacity-0 shadow-red-50 z-10'
      >
        {_.map(_.keys(LanguageFullNameEnum), (lang: LanguageEnum) => (
          <MenuItem key={lang}>
            <LanguageItem lang={lang} fullname={_.get(LanguageFullNameEnum, lang)} />
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
};

export default LanguageSelector;
